import { initialParcelShopFilter, ParcelShop, ParcelShopFilter } from '@app/models';
import { createReducer, on } from '@ngrx/store';
import * as ParcelShopActions from './actions';

import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

export const featureKey = 'parcel-shops';

export interface State {
	parcelShops: ParcelShop[];
	loading: boolean;
	loaded: boolean;
	filter: ParcelShopFilter;
	clock: [day: number, hour: string];
}

export const initialState: State = {
	parcelShops: [],
	loading: false,
	loaded: false,
	filter: initialParcelShopFilter,
	clock: [dayjs().isoWeekday(), dayjs().format('HH:mm:ss.SSS')],
};

export const reducer = createReducer(
	initialState,

	on(ParcelShopActions.loadFromApi, state => ({
		...state,
		loading: true,
	})),
	on(ParcelShopActions.loadSuccess, (state, { parcelShops }) => ({
		...state,
		parcelShops,
		loading: false,
		loaded: true,
	})),
	on(ParcelShopActions.loadFailed, state => ({
		...state,
		loading: false,
		loaded: false,
	})),
	on(ParcelShopActions.setFilterLocation, (state, { location }) => ({
		...state,
		filter: {
			...state.filter,
			location,
		},
	})),
	on(ParcelShopActions.setFilterBounds, (state, { bounds }) => ({
		...state,
		filter: {
			...state.filter,
			bounds,
		},
	})),
	on(ParcelShopActions.setFilterFeatures, (state, { features }) => ({
		...state,
		filter: {
			...state.filter,
			features: {
				...state.filter.features,
				...features,
			},
		},
	})),
	on(ParcelShopActions.setFilterIsOpen, (state, { isOpen }) => ({
		...state,
		filter: {
			...state.filter,
			isOpen,
		},
	})),

	on(ParcelShopActions.updateClock, state => ({
		...state,
		clock: [dayjs().isoWeekday(), dayjs().format('HH:mm:ss.SSS')],
	}))
);
